/**
 * Praten met de eigen API. De browser praat nooit rechtstreeks met de
 * database; alles loopt via `/api/*`.
 */

export class ApiFout extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'ApiFout';
  }
}

async function verzoek<T>(pad: string, opties: RequestInit = {}): Promise<T> {
  const antwoord = await fetch(pad, {
    ...opties,
    headers: {
      ...(opties.body ? { 'Content-Type': 'application/json' } : {}),
      ...opties.headers,
    },
    credentials: 'same-origin',
  });
  const tekst = await antwoord.text();
  let inhoud: { fout?: string } | null = null;
  try {
    inhoud = tekst ? JSON.parse(tekst) : null;
  } catch {
    inhoud = null;
  }
  if (!antwoord.ok) {
    throw new ApiFout(inhoud?.fout ?? 'Er ging iets mis. Probeer het later opnieuw.', antwoord.status);
  }
  return inhoud as T;
}

/**
 * Eén herkansing bij een hapering: alleen bij een serverfout of helemaal
 * geen antwoord, en nooit bij een mutatie.
 */
export async function metHerkansing<T>(werk: () => Promise<T>, pauzeMs = 1200): Promise<T> {
  try {
    return await werk();
  } catch (eerste) {
    const echtAntwoord = eerste instanceof ApiFout && eerste.status >= 400 && eerste.status < 500;
    if (echtAntwoord) throw eerste;
    await new Promise((klaar) => setTimeout(klaar, pauzeMs));
    return werk();
  }
}

export const api = {
  haal: <T>(pad: string) => verzoek<T>(pad),
  stuur: <T>(pad: string, inhoud: unknown = {}, methode = 'POST') =>
    verzoek<T>(pad, { method: methode, body: JSON.stringify(inhoud) }),
};

export type * from './lib/vormen';
